import { CaretDownOutlined, DownOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button, Col, Dropdown, Layout, Row, Space } from 'antd';
import Head from 'next/head';
import ReleaseNotes from './ReleaseNotes';
import AC from '../components/AccessControl';
import VideoPopUp from '../components/panels/VideoPopUp';
import { useSession } from '../lib/hooks';
import { getEnv } from '../environment/resolve';
import appOrigin, { withBrowsingOrigin } from '../helpers/appOrigin';
import styles from './AppHeader.module.scss';
const {
  Header
} = Layout;

// "My Profile" and "Log Out" are myf2b URLs hardcoded per environment, so they
// need the same repointing as the section menu — logging out of stage while
// testing a release environment is the sharpest version of this bug. "Help"
// points at freshdesk and is left alone by the allowlist.
const userMenu = menuLinks => menuLinks.map((link, i) => ({
  key: `link_${i}`,
  label: <a href={withBrowsingOrigin(link.href)}>{link.title}</a>
}));
const separatorProps = {
  disabled: true,
  style: {
    color: '#000000',
    backgroundColor: '#efefef',
    cursor: 'default'
  }
};
// link.url is absolute and built by myf2b from the request host of the GraphQL
// Lambda, so it always names the environment's own appHost — following it from a
// release environment drops you back on stage. withBrowsingOrigin repoints it at
// the host actually being browsed, and leaves External Link items alone.
const headerNav = menuLinks => menuLinks.map((link, i) => ({
  ...(link.type === 'Separator' ? separatorProps : {}),
  key: `link_${i}`,
  label: <a href={withBrowsingOrigin(link.url)}>{link.label}</a>,
  icon: link.imgSrc && <img src={link.imgSrc} className="menu-icon" style={{
    backgroundColor: link.buttonColor
  }} />
}));
const logo = <img className={styles["header-logo"]} src="/assets/f2b_logo.svg" alt="Footsteps2Brilliance" />;
const AppHeader = ({
  extraLeft,
  extraRight,
  currentSection
}) => {
  const {
    user,
    menu
  } = useSession();
  return <Header className={styles["app-header"]} data-sentry-element="Header" data-sentry-component="AppHeader" data-sentry-source-file="AppHeader.jsx">
      <Head data-sentry-element="Head" data-sentry-source-file="AppHeader.jsx">
        <title key="title" children={`F2B - ${currentSection.name}`} />
      </Head>
      <Row type="flex" justify="space-between" align="middle" data-sentry-element="Row" data-sentry-source-file="AppHeader.jsx">
        <Col data-sentry-element="Col" data-sentry-source-file="AppHeader.jsx">
          <span style={{
          display: 'flex',
          height: 'auto',
          alignItems: 'center'
        }}>
            {extraLeft}
            <div className={styles["header-logo-container"]}>
              <a href={appOrigin()} children={logo} />
            </div>
            <div className={styles["header-title"]}>
              <Dropdown menu={{
              items: headerNav(menu)
            }} overlayStyle={{
              minWidth: 'max-content'
            }} data-sentry-element="Dropdown" data-sentry-source-file="AppHeader.jsx">
                <Button onClick={e => e.preventDefault()} type="link" icon={currentSection?.icon} data-sentry-element="Button" data-sentry-source-file="AppHeader.jsx">
                  {currentSection?.name ?? <i>unnamed section</i>}
                  <DownOutlined data-sentry-element="DownOutlined" data-sentry-source-file="AppHeader.jsx" />
                </Button>
              </Dropdown>
            </div>
          </span>
        </Col>
        <Col align="right" data-sentry-element="Col" data-sentry-source-file="AppHeader.jsx">
          <Space size="large" data-sentry-element="Space" data-sentry-source-file="AppHeader.jsx">
            {extraRight}
            
            {!user ? null : <AC.ButtonLink shape="round" icon={<UnorderedListOutlined />} label="Assignment Playlist" href={{
            pathname: '/toolkits/assignment-playlist'
          }} type="primary" className="antd-btn-purple" />}
            <ReleaseNotes data-sentry-element="ReleaseNotes" data-sentry-source-file="AppHeader.jsx" />
            <span>
              {user ? <Dropdown menu={{
              items: userMenu(getEnv().userMenuLinks)
            }}>
                  <a onClick={e => e.preventDefault()}>
                    {`${user.first_name} ${user.last_name}`} <CaretDownOutlined />
                  </a>
                </Dropdown> : <AC.Link label="Log In" href={{
              pathname: '/login'
            }} />}
            </span>
          </Space>
        </Col>
      </Row>
    </Header>;
};
export default AppHeader;